import nlLocale from 'element-ui/lib/locale/lang/nl'
const nl = { //Dutch 荷兰
login:{
buttoo:{
    add:'新增'
}
},
dialog:{
buttton:{
    close:'关闭'
},
ReportError:{
      next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
},
},
Home:{
    Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
 selectCountry:'Selecteer land',
 inputCompany:'Bedrijfsnaam invoeren',
 keWord:'Trefwoord',
 firstWord:"Tekst (woorden van links)",
 searchCompanyNum:"Search 500+ million companies in 200+ countries and territories",
 search:'Zoeken',
 homeSeachTitle:'Wereldwijd zakendoen in beeld',
 homeTitleDetail:'CSI, een datagedreven onderzoeks- en IT-bureau, is gespecialiseerd in krediet, risico en big data. Het biedt digitale tools aan wereldwijde investeerders en zakelijke professionals, waarbij geavanceerde analyses en algoritmen worden gebruikt om snelle, visuele inzichten te bieden die slimmere besluitvorming mogelijk maken.',
 phoneTitleDetail:'Om snel bedrijfsinformatie te zoeken, bekijken en verkrijgen, kunt u ook de CSI-app op uw telefoon gebruiken',
  IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
SearchLeads:"Search Leads",
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 
},
IndustryStatistics:{
    SubjectCompany:"Onderwerp Bedrijf",
    Country:"Land",
    Compare:"Vergelijken",
    Industry:"Branche",
    CompanyType:"Bedrijfstype",
    CompanySize:"Bedrijfsgrootte",
    CompanyStatus:"Bedrijfsstatus",
    YearsinBusiness:"Jaren actief",
    CompanyRating:"Bedrijfsbeoordeling"
},
ListofResults:{
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address',
  Example:'Example',
  message:'message',
  pleaseleaveamessage:'please leave a message',
  Include:'',
  thisaddress:'this company name,ID,address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page',
     CountyCity:'County/City'

},
Toolbar:{
    Filter:"Filter",
    Select:"Selecteren",
    Edit:"Bewerken",
    Sortby:"Sorteren op",
    Collect:"Verzamelen",
    Saved:"Opgeslagen",
    Compare:"Vergelijken",
    Export:"Exporteren",
    Download:"Downloaden",
    Update:"Bijwerken",
    Reporterror:"Fout melden",
    Share:"Delen",
     ascending:'ascending',
    descending:'descending',
    Customfolder:'Custom folder'
},
AiZaba:{
whatareyousearchingfor:'what are you searching for',
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
},
ContentTabs:{
    Background:"Achtergrond",
    BusinessActivities:"Bedrijfsactiviteiten",
    Performance:"Prestaties",
    Publications:"Publicaties",
    CreditOpinion:"Kredietoordeel",
    MarketAnalysis:"Marktanalyse",
    Snapshot:"Snapshot",
    Profile:"Profiel",
    Ownership:"Eigendom",
    RelatedCompanies:"Gerelateerde bedrijven",
    Management:"Management",
    Operations:"Operations",
    Locations:"Locaties",
    Industry:"Branche",
    ImportExport:"Import & Export",
    SupplyChain:"Toeleveringsketen",
    FinancialHighlights:"Financiële hoogtepunten",
    RatioAnalysis:"Ratioanalyse",
    IndustryNorm:"Branchenorm",
    News:"Nieuws",
    Sanctions:"Sancties",
    IndustryStatistics:"Branchestatistieken",
    RatingAnalysis:"Ratinganalyse",
    CompetitiveAnalysis:"Concurrentieanalyse"
},
navigationBar:{
Notifications:'Meldingen',//通知
MarkasRead:'Markeren als gelezen',//标记已读
Viewall:'Alles bekijken',//查看全部
SilverSubscriber:'Zilveren abonnee',//银级用户
Silversubscriberdate:'Vervaldatum Zilver-abonnement',//银级到期日
GoldSubscriber:'Gouden abonnee',//金级用户
Goldsubscriptiondate:'Vervaldatum Goud-abonnement',//金级到期日
AvailableCredits:'Beschikbare credits',//可用积分
AddCredits:'Credits toevoegen',//购买积分
IndivdualAccount:'Individueel account', //个人账号
GroupAccount:'Groepsaccount' //集团账号

},

Snapshot:{
    CompanyDQIdesc:"The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
  CountryDQIdesc:"The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices. Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
  CompanyDQI:'DQI aziendale',//公司数据质量指数 DQI
  CountryDQI:'DQI nazionale',//国家数据质量指数 DQI
  Address:'Indirizzo',//地址
  CountyCity:'Contea/Città',//县/市
  ProvinceState:'Provincia/Stato',//省/州
  CountryRegion:'Paese/Regione',//国家/地区
  ZipCode:'CAP',//邮政编码
  Website:'Sito web',//网站
  Email:'Email',//电邮
  Tel:'Tel',//电话
  LastUpdate:'Ultimo aggiornamento',//最近更新
  DataSource:'数据来源',//数据来源
  LegalStatus:'Rechtsstatus',//法定状况
  CoID:'Bedrijfs-ID',//公司ID
  CompanyType:'Bedrijfstype',//公司类型
  RegistrationDate:'Registratiedatum',//注册日期
  RegistrationStatus:'Registratiestatus',//注册状态
  Listed:'Geregistreerd',//上市信息
  CurrentOpperations:'Huidige activiteiten',//经营状况
  IndustryCode:'Branchecode',//行业代码
  BusinessActivities:'Bedrijfsactiviteiten',//主营业务
  NoofEmployees:'Aantal medewerkers',//员工数量
  NoofShareholders:'Aantal aandeelhouders',//股东数量
  Management:'Management',//管理状况
  Performance:'Prestaties',//业绩表现
  Revenue:'Omzet',//收入
  Assets:'Activa',//资产
  ProfitLoss:'Winst/verlies',//利润
  Growth:'Groei',//公司增长
  Competitiveness:'Concurrentievermogen',//竞争力
  CreditOpinion:'Kredietoordeel',//信用状况
  CreditRating:'Kredietbeoordeling',//信用评级
  CreditScore:'Kredietscore',//信用评分
  ESGRating:'ESG-beoordeling',//ESG 评级
  Solvency:'Solvabiliteit',//偿还能力
  Sanctions:'Sancties',//全球制裁
},
Profile:{
  CompanyProfile:'Bedrijfsprofiel',//基本资料
  CompanyName:'Bedrijfsnaam',//公司名称
  NativeName:'Oorspronkelijke naam',//当地名称
  CompanyID:'Bedrijfs-ID',//公司 ID
  VATNumber:'Aandelencode',//VAT号
  StockCode:'Aandelencode',//股票代码
  Listed:'Geregistreerd',//上市日期
  RegistrationDate:'Registratiedatum',//注册日期
  LegalForm:'Rechtsvorm',//公司性质
  CompanyType:'Bedrijfstype',//公司类型
  LegalStatus:'Rechtsstatus',//注册状态
  Jurisdiction:'Jurisdictie',//司法管辖区
  RegisteredAddress:'Geregistreerd adres',//注册地址
  ProvinceState:'Provincie/Staat',//省/州
  CountryRegion:'Land/Regio',//国家/地区
  ZipCode:'Postcode',//邮政编码
  OperatingAddress:'Bedrijfsadres',//经营地址
  LastUpdate:'Laatste update',//最近更新
  DataSource:'Gegevensbron',//数据来源
  History:'Geschiedenis',//历史记录
    RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',
       CountyCity:'County/City'
},
Ownership:{
 UltimateBeneficiary:'Uiteindelijke begunstigde',//最终受益人
  InvolvingIndividuals:'Particulieren',//涉及自然人股东
  InvolvingEnterprises:'Ondernemingen',//涉及法人股东
  ShareholderLevel:'Aandeelhoudersniveau',//股东层级x
  Name:'Naam',//名称
  Country:'Land',//国家/地区
  Location:'Locatie',//地点
  Type:'Type',//类型
  Shares:'Aandelen',//股份
  Relation:'Relatie',//关系
    Individuals :'Individuals',//关系
        PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'Totaal',//相关公司总计
  Entities:'Entiteiten',//法人实体
  Countries:'Landen',//国家/地区
  Branches:'Vestigingen',//分支机构
  RelatedComp:'Gerelateerde bedrijven',//关联公司
  Name:'Naam',//名称
  Country:'Land',//国家/地区
  Location:'Locatie',//地点
  Type:'Type',//类型
  Relation:'Relatie',//关系
    BranchOffices:'支店',
  Individuals:'個人',
},
Operations:{
   Locations:"Locations",
    Operations:'Operations',
  LineofBusiness:'Bedrijfstak',//业务范围
  BusinessTerritories:'Zakelijke gebieden',//业务区域
  ImportExport:'Import & Export',//进出口信息
  Viewtradeinfo:'Bekijk meer handelsinformatie',//查看更多贸易信息
  ProductsServices:'Producten/Diensten',//产品/服务
  Products:'Producten',//产品
  ProductImage:'Productafbeelding',//产品图片
  ProductName:'Productnaam',//产品名称
  ProductDescription:'Productomschrijving',//产品描述
  Details:'Details',//详情
  Addproductinformation :'Productinformatie toevoegen',//添加产品信息
},
Locations:{
  CoName:'Bedrijfsnaam',//业务范围
  Relationship:'Relatie',//关系
  Country:'Land',//国家/地区
  Location:'Locatie',//地点
  Address:'Adres',//地址
  Edit:'Bewerken',//编辑
  CompanyLocatiionsMap:'Bedrijfslocaties op de kaart',//地图中的公司位置
  Selectaddresstype:'Adrestype selecteren',//选择地址类型
  Subjectcompany:'Onderwerp bedrijf',//目标公司
  Subsidiary:'Dochteronderneming',//子公司
  RegisteredAddress :'Geregistreerd adres',//注册地址
  OperationAddress :'Bedrijfsadres',//运营地址
  All :'Alles',//全部
},
Industry:{
  IndustryTitle:'Branchebeschrijving',//IndustryTitle
  IndustryDescription:'Branchebeschrijving',//IndustryDescription
  ISIC:'ISIC',//ISIC
  ISICDescription:'ISIC-beschrijving',//ISICDescription
  NACE:'NACE',//NACEDescription
  NACEDescription:'NACE-beschrijving',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'NAICS-beschrijving',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'CSIC-beschrijving',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'AAAIC-beschrijving',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'GICS-beschrijving',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Totaal importbedrag',//进口总额
  TopImportCountry:'Top importland',//最大进口国家/地区
  TopImportProduct:'Top importproduct',//最大进口产品
  TotalExport:'Totale export',//出口总额
  TopExportCountry:'Top exportland',//最大出口国家/地区
  TopExportProduct:'Top exportproduct',//最大出口产品
  TradeVolume:'Handelsvolume',//贸易额
  ImportShipments:'Importzendingen',//进口量
  ExportShipments:'Exportzendingen',//出口量
  ImportCountries:'Importlandens',//进口国家/地区
  ExportCountries:'Exportlanden',//出口国家/地区
  ImportVolume:'Importvolume',//进口量
  ExportVolume:'Exportvolume',//出口量
  TopSuppliers:'Topleveranciers',//主要供应商
  ByNumberofShipments:'Op aantal zendingen',//按出货量
  TopBuyers:'Topkopers',//主要买家
  ByNumberofShipments:'Op aantal zendingen',//按出货量
  ImportQuantity:'Importhoeveelheid',//进口数量
  IncreaseDecreasexRate:'Toename-/afnamepercentage',//增/减率
  ExportQuantity:'Exporthoeveelheid',//出口数量
  ImportsExportsRecords:'Import- en exportrecords',//进出口记录
  Date:'Datum',//日期
  Product:'Product',//产品
  HSCode:'HS-code',//HS 编码
  BuyerName:'Naam koper',//买家名称
  Destination:'Bestemming',//目的地
  SupplierName:'Naam leverancier',//供应商名称
  Origin:'Oorsprong',//原产地
  Amount:'Bedrag',//金额
  Details:'Details',//详情
},
 FinancialHighlight:{
      ProfitabilityRatios:'Profitability Ratios',
  OperatingRatios:'Operating Ratios',
  StructuralRatios:'Structural Ratios',
ProductivityRatios:'Productivity Ratios',
GrowthRatios:'Growth Ratios',
  Revenue:'Omzet',//收入
  Profit:'Winst',//利润
  Growth:'Groei',//增长
  Liquidity:'Kasstroomstatus',//现金流状况
  FinancialStructure:'Financiële structuur',//融资结构
  CreditOpinion:'Kredietoordeel',//信用评估
  RiskIndicator :'Risico-indicator',//风险指标
  Solvencyindex:'Solvabiliteitsindex',//偿还指数
  Year:'Jaar',//年份
  Change:'Verandering',//变化
  FinancialHighlights:'Financiële gegevens van de gerelateerde bedrijven',//关联公司财务数据
  FinancialHighlightsTitle:'Financiële hoogtepunten van de gerelateerde bedrijven',//关联公司财务摘要
  CompanyName:'Bedrijfsnaam',//公司名称
  CompanyID:'Bedrijfs-ID',//公司ID
  Country:'Land',//国家/地区
  CompanyStatus:'Bedrijfsstatus',//公司状态
  Relations:'Relaties',//关系
  RatioAnalysis:'Ratioanalyse van de gerelateerde bedrijven'
},
IndustryNorms:{
    IndustryStatistics:"Branchestatistieken",
    ofcompaniesintheIndustry:"Aantal bedrijven in de branche",
    oflistedCompaniesintheIndustry:"Aantal beursgenoteerde bedrijven in de branche",
    oflargecompaniesintheIndustry:"Aantal grote bedrijven in de branche",
    ofSMEsintheIndustry:"Aantal mkb-bedrijven in de branche",
    ofcompaniesinsample:"Aantal bedrijven in de steekproef",
    ofcompaniesinloss:"Aantal bedrijven met verlies",
    Observations:"Observaties",
    AverageValue:"Gemiddelde waarde",
    MedianValue:"Mediaanwaarde",
    MaximumValue10:"Maximale waarde 10%",
    MinimumValue10:"Minimale waarde 10%",
    SubjectCompany:"Onderwerp",
    YearsinBusiness:"Bedrijfsjaren",
    TotalAssets:"Totale activa",
    TotalEquity:"Totaal eigen vermogen",
    Revenue:"Omzet",
    NetEarning:"Nettowinst",
    Returnonassets:"Rendement op activa",
    Performance:"Prestaties",
    ProfitabilityRatios:"Winstgevendheidsratio's",
    Returnonequity:"Rendement op eigen vermogen",
    Returnonassets:"Rendement op activa",
    Grossmargin:"Brutomarge",
    OperatingRatios:"Operationele ratio's",
    Stockturnover:"Omloopsnelheid van de voorraad",
    Accountsreceivableturnover:"Omloopsnelheid van debiteuren",
    Assetsturnover:"Omloopsnelheid van activa",
    Totalassetturnover:"Omloopsnelheid van totale activa",
    StructuralRatios:"Structuurratio's",
    Currentratio:"Current ratio",
    Quickratio:"Quick ratio",
    Shareholdersliquidityratio:"Liquiditeitsratio aandeelhouders",
    GrowthRatios:"Groeiratio's",
    Salesgrowthrate:"Omzetgroei",
    Netprofitgrowthrate:"Groeisnelheid van de nettowinst",
    Totalassetsgrowthrate:"Groeisnelheid van totale activa"
},
 News:{
  Date:'Datum',//日期
  Title:'Titel',//标题
  Source:'Bron',//来源
  Impact:'Impact',//影响
  Searchcompanies:'Zoek meer nieuws over andere bedrijven',//国家/地区
},
 Sanctions:{
  Potentialcompliance:"Er zijn potentiële compliancerisico's gedetecteerd",//检测到潜在合规风险
  SeachbuttonNo:'Er is niets nadeligs gedetecteerd over dit bedrijf',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'Klik op de knop "Sancties zoeken" om meer sanctiegegevens te krijgen.',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'Sancties zoeken',//搜索制裁
  ViewDetails:'Details bekijken',//查看详情
  Sanctions:'Sancties',//制裁
  Potentialcompliancerisks:"SancPotentiële compliancerisico'sties",//潜在合规风险
  IDInfo:'ID-info',//ID 信息
  IDType:'ID-type',//ID 类型
  IDDescription:'ID-beschrijving',//ID 描述
  SanctionList:'Sanctielijst',//制裁名单
  SanctionListInvolved:'Betrokken sanctielijst',//涉及的制裁名单
  StartDate:'Startdatum',//生效日期
  EndDate:'Einddatum',//结束日期
  SourceList:'Bronlijst',//来源名单
  SourceName:'Bronnaam',//来源名称
  ProfileNotes:'Profielnotities',//主体资料
  Link:'Link',//链接
},
CreditOpinion:{
    CreditAssessment:"Kredietbeoordeling",
    CreditAssessmentfromtheRelatedCompanies:"Kredietbeoordeling van de gerelateerde bedrijven",
    Year:"Jaar",
    CreditRating:"Kredietwaardigheid",
    LocalCreditScore:"Lokale kredietscore",
    ProbabilityofDefault:"Kans op wanbetaling",
    SolvencyIndex:"Solvabiliteitsindex",
    CreditLine:"Kredietlimiet",
    RiskIndicator:"Risico-indicator",
    RelatedCreditAssessment:"Gerelateerde kredietbeoordeling",
    CompanyName:"Bedrijfsnaam",
    CompanyID:"Bedrijfs-ID",
    Country:"Land",
    CompanyStatus:"Bedrijfsstatus",
    Relations:"Relaties"
},
RatingAnalysis:{
    IndustyAnalysis:"Brancheanalyse",
    GeographicAnalysis:"Geografische analyse",
    CompanyTypeAnalysis:"Analyse bedrijfstype",
    BiusinessScaleAnalysis:"Analyse bedrijfsschaal",
    HistoryAnalysis:"Historische analyse",
    NormalDistribution:"Normale verdeling",
    SubjectCompany:"Onderwerpbedrijf",
    Probabilityofthesubjectratinginitsindustry:"Waarschijnlijkheid van beoordeling van het onderwerp in zijn branche",
    Maximum:"Maximaal 10%",
    Mean:"Gemiddelde",
    Average:"Gemiddelde",
    Minimum:"Minimaal 10%",
    RatingDistribution:"Beoordelingsverdeling",
    Revenue:"Omzet",
    Earning:"Winst",
    TotalAssets:"Totale activa",
    Subjectratinginitsindustrybyfinancialindicators:"Beoordeling van het onderwerp in zijn branche op basis van financiële indicatoren",
    Best:"Beste",
    Worst:"Slechtste",
    Rankingofsubject:"Rangschikking van de beoordeling van het onderwerp in de branche",
    Industy:"Branche",
    Percentilerank:"Percentielrangschikking: % bedrijven met een score gelijk aan of lager dan de beoordeling van het onderwerp",
    Historicaldevelopmentofsubject:"Historische ontwikkeling van de beoordeling van het onderwerp in zijn branche",
    IndustryAverage:"Gemiddelde in de branche",
    SubjectRatingChanges:"Wijzigingen in beoordeling van het onderwerp"
},
CompetitiveAnalysis:{
    MarketPosition:"Marktpositie",
    Revenus:"Omzet",
    NetEarnings:"Nettowinst",
    NetAssets:"Nettoactiva",
    TotalAssets:"Totale activa",
    Employees:"Medewerkers",
    Mean:"Gemiddelde",
    Average:"Gemiddelde",
    Maximum:"Maximum (10%)",
    Worst:"Slechtste (10%)",
    Subjectcompany:"Onderwerpbedrijf",
    PerformanceComparison:"Prestatievergelijking",
    ProfitabilityRatios:"Winstgevendheidsratio's",
    Grossmargin:"Brutomarge",
    Returnonassets:"Rendement op activa",
    Returnonequity:"Rendement op eigen vermogen",
    Average:"Gemiddelde",
    OperatingRatios:"Operationele ratio's",
    Stockturnover:"Voorraadomloopsnelheid",
    Assetsturnover:"Activaomloopsnelheid",
    Collectionperiod:"Incassoperiode",
    GrowthRatios:"Groeiratio's",
    Totalassetsgrowthrate:"Groeipercentage totale activa",
    Salesgrowthrate:"Omzetgroeipercentage",
    Netprofitgrowthrate:"Groeipercentage nettowinst",
    StructuralRatios:"Structuurratio's",
    Debtratio:"Schuldratio",
    Quickratio:"Quick ratio",
    Currentratio:"Current ratio"
},
AccountCenterMenu:{
SearchinSettings:"Zoeken in Instellingen",//在“设置”中搜索
Account:"Account",//账户
MyAccount :"Mijn account",//我的账户
ContactInfo:"Contactgegevens",//联系信息
AccountSecurity:"Accountbeveiliging",//账户安全
OrganizationalManagement:"Organisatiebeheer",//组织管理
UserGroup:"Gebruikersgroep",//用户组
User:"Gebruiker",//用户
Role:"Rol",//角色
MyDatabase:"Mijn database",//我的数据库
MyUsage:"Mijn gebruik",//我的使用情况
CompaniesViewed:"Bekeken bedrijven",//查看过的公司
ReportsDownloaded:"Gedownloade rapporten",//下载的报告
ReportUpdatesOrdered:"Bestelde rapportupdates",//订购的报告更新
BillingandPayment:"Facturering en betaling",//账单和付款
BillRecords:"Rekeninggegevens",//账单记录
PaymentRecords:"Betalingsgegevens",//付款记录
CreditDeductions:"Creditaftrek",//信用扣款
InvoicesDownloaded:"Gedownloade facturen",//下载的发票
UserSettings:"Gebruikersinstellingen",//用户设置
Messages:"Berichten",//消息
Notifications:"Meldingen",//通知
HelpCenter:"Helpcentrum",//帮助中心
FAQ:"Veelgestelde vragen",//常见问题
Privacy:"Privacy",//隐私
Terms:"Voorwaarden",//条款
ReportIssues:"Problemen melden",//报告问题
UserGuide:"Gebruikershandleiding",//用户指南
AboutCSI:"Over CSI"//关于CSI


},
MyAccount:{
Logintime:'Inlogtijd',//登录时间
SignOut:'Afmelden',//退出
DeleteAccount:'Account verwijderen',//删除账户
AccountID:'Account-ID',//账户ID
Enteranewaddress:'Voer een nieuw e-mailadres in',//输入新的电邮
EnterVerificationCode:'Voer verificatiecode in',//输入验证码
SendverificationCode:'Verificatiecode verzenden',//发送验证码
Password:'Wachtwoord',//密码
Originalpassword:'Oorspronkelijk wachtwoord',//原始密码
Newpassword:'Nieuw wachtwoord',//新密码
Confirmnewpassword:'Bevestig nieuw wachtwoord',//确认新密码
AccountOwnership:'Accounteigendom',//账户所有权
IndividualAccount:'Individueel account',//个人账户
GroupAccount:'Groepsaccount',//集团账户
Organizationname:'Organisatienaam',//机构名称
CountryRegion:'Land/Regio',//国家/地区
Address:'Adres',//地址
City:'Plaats',//城市
ZipCode:'Postcode',//邮政编码
FirstName:'Voornaam',//名字
LastName:'Achternaam',//姓氏
PhoneNumber:'Telefoonnummer',//电话号码
Email:'E-mailadres',//更改
Change:'Wijzigen',//更改
Save:'Opslaan',//保存
Cancel:'Annuleren',//取消
LastLogin:'Laatste aanmelding',//Last Login
RecentLogin:'Recente aanmelding',//登录尝试次数
AverageLoginTime:'Gemiddelde inlogtijd',//平均登录时间
TotalLoginAttempts:'Totaal aantal inlogpogingen',//登录尝试次数

},
ShippingOrderDetails:{
    Date:"Datum",
    MasterBillofLading:"Master Bill of Lading",
    Source:"Bron",
    BillNo:"Factuurnummer",
    ImporterBuyer:"Importeur/koper",
    ExporterSeller:"Exporteur/verkoper",
    Name:"Naam",
    Address:"Adres",
    Country:"Land",
    Contact:"Contactpersoon",
    Email:"E-mailadres",
    CargoInfo:"Ladinginformatie",
    HSCode:"HS-code",
    Quantity:"Hoeveelheid",
    WeightUnit:"Gewichtseenheid",
    ProductDescription:"Productomschrijving",
    Amount:"Hoeveelheid",
    QuantityUnit:"Hoeveelheidseenheid",
    Weight:"Gewicht",
    HSDescription:"HS-omschrijving",
    Incoterms:"Incoterms",
    ShippingInfo:"Verzendinformatie",
    Vessel:"Schip",
    Consignee:"Geadresseerde",
    MeansofTransport:"Vervoermiddel",
    CountryofOrigin:"Land van herkomst",
    Voyage:"Reis",
    Notifier:"Kennisgever",
    CountryofDestnation:"Land van bestemming",
    AddressofOrigin:"Adres van herkomst",
    Shipper:"Verzender",
    AddressofDestnation:"Adres van bestemming",
    Container:"Container",
    ContainerID:"Container-ID",
    ContainerType:"Containertype",
    ContainerDescDode:"Containeromschrijving",
    ContainerSize:"Containergrootte"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"Welke soorten fouten meldt u?",
    Tellusmoreaboutyourproblems:"Vertel ons meer over uw problemen.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Wilt u een screenshot of een bestand met betrekking tot uw probleem meesturen?",
    Fillinyourcontactinformation:"Vul uw contactgegevens in",
    FirstName:"Voornaam",
    LastName:"Achternaam",
    PhoneNumber:"Telefoonnummer",
    Email:"E-mailadres"
},
UserSettings:{
    LanguageandLocation:"Taal en locatie",
    Language:"Taal",
    Selectyourpreferedlanguage:"Selecteer uw voorkeurstaal",
    Location:"Locatie",
    Selectyourlocation:"Selecteer uw locatie",
    NotificationSetting:"Meldingsinstellingen",
    EmailNotification:"E-mailmeldingen",
    ServiceUpdates:"Service-updates",
    CompanyNews:"Bedrijfsnieuws"
},
ContactInfo:{
    ContactInfo:"Contactgegevens",
    FirstName:"Voornaam",
    LastName:"Achternaam",
    PhoneNumber:"Telefoonnummer",
    Email:"E-mailadres",
    CountryRegion:"Land/Regio",
    AddressLine:"Adresregel",
    City:"Plaats",
    ZipCode:"Postcode",
    Alternativecontactperson:"Alternatieve contactpersoon",
    Setascontactperson:"Instellen als contactpersoon",
    Edit:"Bewerken"
},
AccountSecurity:{
    Setupmysecurityquestions:"Stel mijn beveiligingsvragen in",
    Pleasechooseaquestion:"Kies een vraag",
    Pleaseentertheanswertothequestion:"Voer het antwoord op de vraag in",
    SessionTimeoutAutomaticLogoutSettings:"Sessie-time-out: Instellingen voor automatisch uitloggen",
    Thesystemwillautomatically:"Het systeem logt u automatisch uit na een periode van inactiviteit. De standaardtime-out is ingesteld op 5 minuten, maar u kunt deze duur naar wens aanpassen."
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"Totaal aantal gezochte bedrijven",
    TotalNumberofCompaniesCollected:"Totaal aantal verzamelde bedrijven",
    TotalNumberofUpdateReportsOrdered:"Totaal aantal bestelde updaterapporten",
    Date:"Datum",
    UserName:"Gebruikersnaam",
    CompanyName:"Bedrijfsnaam",
    Status:"Status",
    UsageType:"Gebruikstype",
    Entercompanyname:"Voer de bedrijfsnaam in",
    Download:"Downloaden"
},
OrganizationalManagement:{
    GroupName:"Groepsnaam",
    ParentGroupName:"Naam bovenliggende groep",
    Organization:"Organisatie",
    GroupID:"Groeps-ID",
    GroupStatus:"Groepsstatus",
    Operation:"Bewerking",
    NewlyBuilt:"Nieuw aangemaakt",
    UserAccount:"Gebruikersaccount",
    Role:"Rol",
    AccountStatus:"Accountstatus",
    RoleName:"Rolnaam",
    Position:"Positie",
    RoleStatus:"Rolstatus",
    Valid:"Geldig",
    Invalid:"Ongeldig",
    PermissionSettings:"Instellingen"
},
BillingandPayment:{
    TotalNumberofOrders:"Totaal aantal bestellingen",
    TotalPaymentAmount:"Totaal betaald bedrag",
    TotalDeductionCredits:"Totaal afgetrokken credits",
    Date:"Datum",
    UserAccount:"Gebruikersaccount",
    CompanyName:"Bedrijfsnaam",
    OrderNo:"Ordernummer",
    OrderType:"Ordertype",
    OrderStatus:"Orderstatus",
    Download:"Downloaden",
    PaymentAmount:"Betaalbedrag",
    Contactus:"Contact",
    DownloadInvoice:"Factuur downloaden",
    CreditsDeducted:"Afgetrokken credits",
    ReportOrderStatus:"Orderstatus rapporteren",
    CompanyID:"Bedrijfs-ID",
    CountryRegion:"Land/Regio",
    AddressLine:"Adresregel",
    City:"Plaats",
    ZipCode:"Postcode",
    FirstName:"Voornaam",
    LastName:"Achternaam",
    PhoneNumber:"Telefoonnummer",
    Email:"E-mailadres",
    BankAccountHolderName:"Naam bankrekeninghouder",
    BeneficiaryBankName:"Naam begunstigde",
    SWIFTCODE:"SWIFT-CODE",
    AccountNumber:"Rekeningnummer",
    BeneficiaryBankAddress:"Adres bank begunstigde",
    ABA:"ABA (routingnummer)",
    IBANnumber:"IBAN-nummer"
},
JiuGuoge:{
  Country:'Country',
  Industry:'Industry',
  CoSize:'Co. Size',
  Liquidity:'Liquidity',
  NoofcoinIndustry:'No. of co. in Industry',
  IndustryRating:'Industry Rating',
  Profitability:'Profitability',
  Growth:'Growth',
  FinancialStructurt:'Financial Structurt',
  Repaying:'Repaying',
},
  ...nlLocale
}

export default nl